export default __webpack_public_path__ + "assets/images/coins.4410fc.avif";